export default __webpack_public_path__ + "static/media/instagram.2d5cedd5.png";